export const SOFT_NAV_STATE = Object.freeze({
  INITIAL: 'soft-nav:initial',
  START: 'soft-nav:start',
  REPLACE_MECHANISM: 'soft-nav:replace-mechanism',
  SUCCESS: 'soft-nav:success',
  ERROR: 'soft-nav:error',
  FRAME_UPDATE: 'soft-nav:frame-update',
  END: 'soft-nav:end',
  RENDER: 'soft-nav:render',
  REACT_DONE: 'soft-nav:react-done',
  PROGRESS_BAR: {
    START: 'soft-nav:progress-bar:start',
    END: 'soft-nav:progress-bar:end',
  },
})
